const VALIDATION_MESSAGES = {
  "step1Status1_pickOne": "Please only pick one option for the status",
  "step1Status2_pickOne": "Please only pick one option for the status",

  "requiredAction1_required": "Please fill out 'required action'",
  "requiredAction2_required": "Please fill out 'required action'"
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "status1_pass": () => ({ validate: () => {
        const yesOrNo = ["status1_pass", "status1_hazard"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['step1Status1_pickOne'];
      },
    }),
    "status2_pass": () => ({
      validate: () => {
        const yesOrNo = ["status2_pass", "status2_hazard"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['step1Status2_pickOne'];
      },
    }),

    "requiredAction1": () => ({
      validate: {
        required: (requiredAction1) => {
          return (!!requiredAction1) || VALIDATION_MESSAGES['requiredAction1_required']
        }
      },
    }),
    "requiredAction2": () => ({
      validate: {
        required: (requiredAction2) => {
          return (!!requiredAction2) || VALIDATION_MESSAGES['requiredAction2_required']
        }
      },
    }),
  };
};

export default useValidation;
